export default __webpack_public_path__ + "static/media/2465.8fd29dcf.png";